module.exports = "<app-page-container>\nMy games\n</app-page-container>\n"